var custom = {
  init: function(){
  	custom.searchExpand();
    custom.sliderHome();
    custom.sliderCourses();
    custom.countDown();
    custom.sliderGallery();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.toggleUserCourse();
  },
  sliderHome: function(){
    if($(".slider-home").length){
      $('.slider-home').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',
        prevArrow: $('.prev'),
        nextArrow: $('.next')
      });
      /*$('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-info').removeClass('aos-init').removeClass('aos-animate');
      });
      $('.slider-home').on('afterChange', function(event, slick, currentSlide, nextSlide){
        AOS.refresh();
      });*/
    }
  },
  sliderCourses: function(){
    if($(".slider-courses").length){
      $('.slider-courses').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      
    }
  },
  searchExpand: function(){
    function buttonUp(){
      var inputVal = $('.searchbox-input').val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
        $('.searchbox-icon').css('display','none');
      } else {
        $('.searchbox-input').val('');
        $('.searchbox-icon').css('display','block');
      }
    }
    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchbox');
    var isOpen = false;
    submitIcon.click(function(){
      if(isOpen == false){
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
      }
    });  
    submitIcon.mouseup(function(){
      return false;
    });
    searchBox.mouseup(function(){
      return false;
    });
    $(document).mouseup(function(){
      if(isOpen == true){
        $('.searchbox-icon').css('display','block');
        submitIcon.click();
      }
    });
  },
  countDown: function(){
    if($(".listTiempo").length){
      $('[data-countdown]').each(function () {
        var $this = $(this), finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  },
  sliderGallery: function(){
    if($(".gallery-event").length){
      $('.gallery-event').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  },
  mapMarket: function(){
    if($(".map-canvas").length){
      var lat = $(".map-canvas").data("lat");
      var log = $(".map-canvas").data("lon");
      var direc = $(".map-canvas").data("direc");

      var map = new google.maps.Map($('.map-canvas')[0], {
          zoom: 16,
          center: new google.maps.LatLng(lat,log)
      });
      var marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(lat,log)
      });
      var info = new SnazzyInfoWindow({
          marker: marker,
          closeOnMapClick: false,
          content: direc
      });
      info.open();
    }
  },
  sidebarStickitCustom: function(){
    if($('.sidebar-stickit-custom').length){
      $('.sidebar-stickit-custom').stickit({
        screenMinWidth: 992,
        top: 60
      });
    }  
  },
  toggleUserCourse: function(e){
    if($(".info-text-autor").hasClass("toggle-active")){
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    }else{
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  }
}
